/**
 * Thank You marketing page (`/thank-you`) — GitHub issue "Create React
 * components for static marketing pages using vite-react-ssg".
 * Statically generated; no client-side data fetching or auth dependency.
 */
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import MarketingLayout from '@/components/marketing/MarketingLayout';
import SeoHead from '@/components/marketing/SeoHead';
import { Button } from '@/components/ui/button';

export default function ThankYouPage(): JSX.Element {
  const { t } = useTranslation();

  return (
    <MarketingLayout>
      <SeoHead
        title={t('marketing.thankYou.title')}
        description={t('marketing.thankYou.description')}
        path="/thank-you"
      />

      <section className="container mx-auto max-w-2xl px-4 py-24 text-center">
        <h1 className="text-4xl font-bold tracking-tight sm:text-5xl">
          {t('marketing.thankYou.heading')}
        </h1>
        <p className="mt-4 text-xl text-muted-foreground">{t('marketing.thankYou.subheading')}</p>
        <div className="mt-8">
          <Button size="lg" asChild>
            <Link to="/">{t('marketing.thankYou.cta')}</Link>
          </Button>
        </div>
      </section>
    </MarketingLayout>
  );
}
